import styles from "./TextInput.css";
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";


export default class TextInput extends React.Component {
  static propTypes = {
    positioningClassName: PropTypes.string,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    showValidation: PropTypes.bool,
    type: PropTypes.oneOf(["text", "email"]),
    validationFunction: PropTypes.func
  }

  static defaultProps = {
    showValidation: false,
    type: "text"
  }

  constructor (props) {
    super(props);
  }

  state = {
    value: "",
    isValid: false
  }

  onChange = (event) => {
    const value = event.target.value;
    let isValid = true;

    if (this.props.validationFunction) {
      isValid = this.props.validationFunction(value);
    }

    this.setState({
      value: value,
      isValid
    });
  }

  render () {
    const showInvalid = this.props.showValidation && !this.state.isValid;
    const { placeholder, maxLength, positioningClassName, type } = this.props;

    return (
      <div className={positioningClassName}>
        <input
          className={classnames(styles.input, { [styles.invalid]: showInvalid })}
          type={type}
          placeholder={placeholder}
          maxLength={maxLength}
          value={this.state.value}
          onChange={this.onChange} />
      </div>
    );
  }

}
